import React, { MouseEvent } from 'react';
import { ReactSVG } from 'react-svg';
import styles from './inline-svg.css';


type InlineSvgProps = {
  src: string;
  onClick?: (event?: MouseEvent<HTMLElement>) => void;
  dataAttributes?: object;
  className?: string;
};

const InlineSvg = ({
  src,
  onClick,
  dataAttributes,
  className,
}: InlineSvgProps) => (
  <ReactSVG
    src={src}
    className={`${styles.container} ${className || ''}`}
    onClick={onClick}
    {...dataAttributes}
  />
);

export default InlineSvg;
